<template>
  <el-card
    id="myMeetingCard"
    v-loading="loading"
    shadow="hover"
    class="clear-card myMeeting"
    :body-style="{boxSizing: 'border-box', height: 'calc(100% - 59px)'}"
    :class="$mq"
  >
    <div
      slot="header"
      class="clearfix title defaultCursor"
    >
      <span>{{ $t('leader.meeting.nextMeeting') }}</span>
    </div>
    <div class="content">
      <div
        v-if="!previewMode && status && status.next_meeting"
        class="meeting"
        @click="goToMeeting(true)"
      >
        <span>{{ status.next_meeting }}</span>
      </div>

      <el-tooltip
        v-else
        class="tooltip"
        effect="dark"
        :content="$t('leader.meeting.descTooltip')"
        placement="top"
        :disabled="!disabled"
      >
        <div
          class="no-data"
          @click="goToMeeting(!disabled)"
        >
          <span>{{ $t('leader.meeting.bookNext') }}</span>
        </div>
      </el-tooltip>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      loading: (state) => state.processStatus.loading,
      status: (state) => state.processStatus.process,
    }),

    ...mapGetters('myCoach', {
      hasCoach: 'hasCoach',
    }),

    disabled() {
      return ['pending', 'on_hold'].includes(this.status.meeting_status);
    },

    meetingSession() {
      const session = 0;
      if (!this.status) return session;

      // if (!this.status.next_meeting) {
      //   session = this.status.session_id === 'on_boarding'
      //     ? this.status.next_session_id
      //     : this.status.session_id;
      // } else {

      // }

      return session;
    },
  },

  methods: {
    goToMeeting(status) {
      if (status && this.hasCoach) {
        this.$router.push({
          name: 'schedule',
        })
          .catch(() => {});
      } else if (status && !this.hasCoach) {
        this.$router.push({
          name: 'coachSelection',
        })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #myMeetingCard {
    height: 100%;

    .title {
      text-align: center;
    }

    &:not(.mobile):not(.tablet) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    .content {
      cursor: pointer;
      text-align: center;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .meeting {
        color: var(--themeFontColor);
        font-weight: bold;
        font-size: 20px;
      }

      .no-data {
        font-style: italic;
        text-decoration: underline;
      }
    }
  }
</style>

<style lang="scss">
  #myMeetingCard {
    .el-card__header {
      font-weight: bold;
      padding-left: 0;
      padding-right: 0;
    }

    &.mobile,
    &.tablet {
      .el-card__header {
        border-bottom: 0;
      }
    }
  }
</style>
